export default {"src":"/_next/static/media/roadwise-logo-white-en.72c78cdf.svg","height":47,"width":109,"blurWidth":0,"blurHeight":0};